/**
 * Строки стартового экрана, статистики, оценок, пожеланий и политики конфиденциальности.
 * Префиксы `start*`, `stats*`, `rate*`, `fb*`, `policy*` — не пересекаются с соседними файлами.
 */
export const EXTRAS_STRINGS = {
  // ── Стартовый экран ──
  startTagline: ['Удобная онлайн-запись', 'Qulay onlayn yozilish'],
  startBookT: ['Записаться', 'Yozilish'],
  startBookS: [
    'Найдите специалиста и выберите удобное время',
    'Mutaxassisni toping va qulay vaqtni tanlang',
  ],
  startBizT: ['Принимать записи', 'Yozuvlarni qabul qilish'],
  startBizS: [
    'Добавьте свой бизнес и управляйте клиентами',
    'Biznesingizni qoʻshing va mijozlarni boshqaring',
  ],
  startF1: ['Удобное время', 'Qulay vaqt'],
  startF2: ['Без лишних звонков', 'Ortiqcha qoʻngʻiroqlarsiz'],
  startF3: ['Надёжно и безопасно', 'Ishonchli va xavfsiz'],
  startF4: ['Прямо в Telegram', 'Toʻgʻridan-toʻgʻri Telegramda'],
  startMore: ['Больше возможностей для вас', 'Siz uchun koʻproq imkoniyatlar'],
  home: ['На главную', 'Bosh sahifa'],

  // ── Статистика и рейтинг кабинета ──
  navStats: ['Статистика', 'Statistika'],
  statsTitle: ['Статистика', 'Statistika'],
  statsDay: ['Дни', 'Kunlar'],
  statsWeek: ['Недели', 'Haftalar'],
  statsMonth: ['Месяцы', 'Oylar'],
  statsVisits: ['Записи', 'Yozuvlar'],
  statsClients: ['Клиенты', 'Mijozlar'],
  statsCompleted: ['Пришли', 'Kelishdi'],
  statsNoShow: ['Не пришли', 'Kelishmadi'],
  statsCancelled: ['Отмены', 'Bekor qilindi'],
  statsCurrent: ['Текущий период', 'Joriy davr'],
  statsTotalRange: ['За весь показанный период', 'Koʻrsatilgan butun davr uchun'],
  statsRating: ['Рейтинг', 'Reyting'],
  statsRegulars: ['Постоянные клиенты', 'Doimiy mijozlar'],
  statsNoRegulars: [
    'Пока никто не приходил больше одного раза за этот период.',
    'Bu davrda hali hech kim bir martadan koʻp kelmagan.',
  ],
  statsVisitsCount: ['визитов', 'tashrif'],
  statsNoRating: [
    'Оценок пока нет. Клиенты оценивают визит после того, как вы отметите его завершённым.',
    'Hozircha baholar yoʻq. Mijozlar tashrifni siz uni yakunlangan deb belgilaganingizdan keyin baholaydi.',
  ],
  statsRatingCount: ['оценок', 'baho'],

  // ── Оценка визита клиентом ──
  rateAsk: ['Оцените визит', 'Tashrifni baholang'],
  rateDone: ['Ваша оценка', 'Sizning bahoingiz'],
  rateStar: ['звёзд', 'yulduz'],
  noRatings: ['Нет оценок', 'Baholar yoʻq'],

  // ── Пожелания ──
  fbTitle: ['Пожелания', 'Takliflar'],
  fbOpen: ['Оставить пожелание', 'Taklif qoldirish'],
  fbSub: [
    'Что улучшить или добавить? Сообщение придёт команде в Telegram.',
    'Nimani yaxshilash yoki qoʻshish kerak? Xabar jamoaga Telegramda keladi.',
  ],
  fbPh: ['Напишите ваше пожелание…', 'Taklifingizni yozing…'],
  fbSend: ['Отправить', 'Yuborish'],
  fbThanks: ['Спасибо! Мы получили ваше сообщение.', 'Rahmat! Xabaringizni oldik.'],

  // ── Неявки в профиле клиента ──
  profNoShowT: ['Неявки', 'Kelmaganlar'],
  profNoShowNone: [
    'Неявок нет. Так держать — отменяйте заранее, если планы меняются.',
    'Kelmaganlar yoʻq. Rejalar oʻzgarsa, oldindan bekor qiling.',
  ],
  profNoShowSome: [
    'За последние 90 дней вы не пришли {n} раз(а). При повторных неявках запись ограничивается.',
    'Soʻnggi 90 kunda siz {n} marta kelmadingiz. Takroriy kelmaslikda yozilish cheklanadi.',
  ],
  profRules: ['Как работают ограничения', 'Cheklovlar qanday ishlaydi'],


  /** Одна подсказка специализации на все отрасли — что писать, а не пример чужой профессии. */
  titlePh: ['Коротко: чем вы занимаетесь', 'Qisqacha: nima bilan shugʻullanasiz'],

  // ── Выбор услуги ──
  srvName: ['Услуга', 'Xizmat'],
  srvPick: ['Выберите услугу', 'Xizmatni tanlang'],
  /* Одна подсказка на все отрасли — без примера, чтобы не называть чужую профессию. */
  /* Подсказка на языке самого поля, а не интерфейса: RU-поле по-русски, UZ-поле по-узбекски. */
  srvNamePh: ['Введите название услуги', 'Введите название услуги'],
  srvNamePhUz: ['Xizmat nomini kiriting', 'Xizmat nomini kiriting'],
  srvCustom: ['Другая услуга', 'Boshqa xizmat'],

  // ── Ссылка и QR для бизнеса ──
  shareTitle: ['Ссылка и QR-код', 'Havola va QR-kod'],
  shareHint: [
    'Отправьте ссылку клиентам или распечатайте QR: по ним сразу открывается запись к вам. Ссылка не меняется, даже если вы переименуетесь, — напечатанные QR продолжат работать.',
    'Havolani mijozlarga yuboring yoki QR-ni chop eting: ular orqali darhol sizga yozilish ochiladi. Nomni oʻzgartirsangiz ham havola oʻzgarmaydi — chop etilgan QR ishlashda davom etadi.',
  ],
  shareCopy: ['Скопировать', 'Nusxalash'],
  shareCopied: ['Скопировано', 'Nusxalandi'],
  shareSend: ['Поделиться', 'Ulashish'],
  shareDownload: ['Скачать QR для печати', 'Chop etish uchun QR yuklab olish'],
  shareText: ['Записывайтесь онлайн:', 'Onlayn yoziling:'],

  // ── Пригласить коллегу (реферальная программа) ──
  /* Числа в условиях подставляются из `REFERRAL` в @app/shared, а не вписаны в строку. */
  refTitle: ['Пригласить коллегу', 'Hamkasbni taklif qilish'],
  refRule: [
    'Мастер-одиночка запустил работу — +{solo} дн., организация — +{team} дн. к вашей подписке. Награда приходит, когда приглашённый опубликует свою организацию, не за регистрацию. Не больше {max} приглашений.',
    'Yakka usta ishni boshlasa — +{solo} kun, tashkilot — +{team} kun obunangizga. Mukofot taklif qilingan kishi tashkilotini e’lon qilganda beriladi, roʻyxatdan oʻtgani uchun emas. {max} tadan ortiq taklif uchun berilmaydi.',
  ],
  refInvited: ['Приглашено', 'Taklif qilingan'],
  refDays: ['Получено дней', 'Olingan kunlar'],
  refShareText: ['Ведите запись клиентов в Telegram:', 'Mijozlar yozuvini Telegramda yuriting:'],

  // ── Политика ──
  policyTitle: ['Политика конфиденциальности', 'Maxfiylik siyosati'],
} as const satisfies Record<string, readonly [string, string]>;
